import Axios from 'axios'

export function getMonthWeek(year, month, date) {
  let dateNow = new Date(year, parseInt(month) - 1, date);
  let w = dateNow.getDay();
  let d = dateNow.getDate();
  return Math.ceil((d + 6 - w) / 7);
}

//封装
export function getYearWeek(year, month, date) {
  let dateNow = new Date(year, parseInt(month) - 1, date);
  let dateFirst = new Date(year, 0, 1);
  let dataNumber = Math.round((dateNow.valueOf() - dateFirst.valueOf()) / 86400000);
  return Math.ceil((dataNumber + ((dateFirst.getDay() + 1) - 1)) / 7) - 1;
}

//封装日期
export function getYearMonthDay(val, Flag) {
  if (val == null) {
    var date = new Date();
  } else {
    var date = new Date(val);
  }
  var Y = date.getFullYear();
  var M = '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var D = '-' + (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
  var time = '';
  switch (Flag) {
    case 'yyyy':
      time = Y;
      break;
    case 'yyyy-MM':
      time = Y + M;
      break;
    case 'yyyy-MM-dd':
      time = Y + M + D;
      break;
    case 'hh-MM-ss':
      time = h + m + s;
      break;
    case 'yy--mm':
      time = Y + M + D + ' ' + h + m;
      time = time.substr(0,time.length-1)
      break;
    case 'yy--ss':
      time = Y + M + D + ' ' + h + m + s;
      break;
    case 'zh':
      M =  M.substr(1,M.length-1)
      D =  D.substr(1,D.length-1)
      h =  h.substr(0,h.length-1)
      m =  m.substr(0,D.length-1)
      h = h * 1
      if (h < 12) {
        h = '上午 ' + h + '点'
      } else {
        h = '下午 ' + (h - 12) + '点'
      }
      if(m>0){
        m =  m +  '分'
      }else {
        m = ''
      }
      time = Y + '年' + M + '月' + D + '日'  + ' ' + h + m;
      break;
  }
  return time;
}

//封装文件大小限制
export function judgeSizer(Now, standard) {
  if (Now / 1024 / 1024 > standard) {
    return false
  } else {
    return true;
  }
}

//封装时间年份区间
export function fun_date(num, date) {
  var date1 = new Date(date);
  var date2 = new Date(date1);
  date2.setDate(date1.getDate() + num);
  var time2 = ((date2.getMonth() + 1) > 9 ? (date2.getMonth() + 1) : '0' + (date2.getMonth() + 1)) + "-" + (date2.getDate() > 9 ? date2.getDate() : '0' + date2.getDate());
  return time2;
}

//保留两位小数
export function fomatFloar(num, n) {
  var f = parseFloat(num);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
  var s = f.toString();
  var rs = s.indexOf('.');
  //判定如果是整数，增加小数点再补0
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + n) {
    s += '0';
  }
  return s * 1000 / 10;
}

//计算年月日和时间的封装
export function timestampToTime(timestamp, Flag) {
  var date = new Date(timestamp);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  if (Flag) {
    var time = Y + M + D;
  } else {
    var time = Y + M + D + ' ' + h + m + s;
  }
  return time;
}

//下载文件封装
export function download(config) {
  Axios.get(config.url, {
    responseType: 'blob'
  }).then(res => {
    const data = res.data
    const fileReader = new FileReader()
    fileReader.onload = function () {
      try {
        const jsonData = JSON.parse(this.result)
        if (jsonData.status < 400) {
          return
        }
        Message({
          message: jsonData.message,
          type: 'warning'
        })
        return
      } catch (err) {
        // 解析成对象失败，说明是正常的文件流
        const blob = data
        const a = document.createElement('a')
        const url = (window.URL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob)
        a.href = url
        a.download = config.name
        a.click()
        window.URL.revokeObjectURL(url)
      }
    }
    fileReader.readAsText(data)
  })
}

//表格总计封装
//传入格式
// let sums = [];
// if(params.data.length > 0){
//     sums = tableSums(params,1,[2,3,4,5,6,7,8,9,10,11],[0,12,13,14]);
// }
// return sums;
//方法
export function tableSums(params, text, Arr, Brr) {
  const { columns, data } = params
  const sums = []
  columns.forEach((column, index) => {

    //总计的下标
    if (index === text) {
      sums[index] = '总计'
      return
    }

    //为空的数组
    Brr.forEach((item, i) => {
      if (index === Number(Brr[i])) {
        sums[index] = ''
      }
    });

    //计算的数组
    Arr.forEach((item, i) => {
      if (index === Number(Arr[i])) {
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          let num = 0;
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              num++
              return (prev + curr)
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = '-'
        }
      }
    });

  });
  return sums;
}

//根据Id查返回对应的部门
export function worksList(works, list) {
  var MapList = new Map()
  works.forEach((item) => {
    MapList.set(item.id, item)
  })
  var Lister = ''
  if (list != undefined) {
    if (typeof (list) == 'string') {
      list = list.split(",");
    }
    list.forEach((item) => {
      if (Lister == '') {
        Lister = MapList.get(item).name;
      } else {
        Lister += ',' + MapList.get(item).name;
      }
    })
    return Lister;
  }
}

//两个接口进行数据替换总计
//传入格式
// let sums = [];
// if(params.data.length > 0){
//     sums = tableSums(params,获取数据,1,[2,3,4,5,6,7,8,9],[0,12,13,14],[10,11]);
// }
// return sums;
//方法
export function tableSumReplace(params, list, text, Arr, Brr) {
  list.length = list.length - 1;
  const { columns, data } = params
  const sums = []
  columns.forEach((column, index) => {
    //总计的下标
    if (index === text) {
      sums[index] = '总计'
      return
    }
    //计算的数组
    Arr.forEach((item, i) => {
      if (index === Number(Arr[i])) {
        list.forEach((ite, j) => {
          if (list[j].SCHEDULESTATE == Arr[i]) {
            sums[index] = list[j].COUNT;
          } else {
            sums[index] = '-'
          }
        });
      }
    });
    //为空的数组
    Brr.forEach((item, i) => {
      if (index === Number(Brr[i])) {
        sums[index] = ''
      }
    });
  });
  return sums;
}
